import { z } from 'zod'
import { idSchemaV2, isId, UserIdSchema } from '../ids'
import { DispositionIdSchema } from '../disposition'
import { AuditPropsSchema } from '../common'
import { ArchivableSchema } from '../archive'

export const TagIdSchema = idSchemaV2('Tag')
export type TagId = z.infer<typeof TagIdSchema>
export const isTagId = isId(TagIdSchema)

export const UnsavedTagSchema = z.object({
  tagId: TagIdSchema.optional(),
  label: z.string().min(1),
  color: z.string(),
  icon: z.string(),
  short: z.string().optional(),
})
export type UnsavedTag = z.infer<typeof UnsavedTagSchema>

export const TagDataSchema = UnsavedTagSchema.extend({
  ...UnsavedTagSchema.omit({ tagId: true }).shape,
  ...AuditPropsSchema.shape,
  ...ArchivableSchema.shape,
  tagId: TagIdSchema,
  entityId: UserIdSchema,
  dispositionId: DispositionIdSchema.optional(),
})
export type TagData = z.infer<typeof TagDataSchema>

export const TagSortSchema = z.object({
  recency: z.boolean().optional(),
  usage: z.enum(['most', 'least']).optional(),
})
export type TagSort = z.infer<typeof TagSortSchema>
